import { basicAxios } from "../../sevices/baseAxios";



//get users list
export const getAccountUsers = async (data) => {
  const response = await basicAxios.get(`/api/Account/GetUsers?pageSize=${data.pageSize}&pageIndex=${data.pageIndex}`);
  return response.data;
};

export const getAccountUserById = async (id) => {
  const response = await basicAxios.get(`/api/Account/GetUserById?id=${id}`);
  return response.data;
};

export const getDeleteAccountUserById = async (id) => {
  const response = await basicAxios.delete(`/api/Account/DeleteUserById?id=${id}`);
  return response.data;
};

export const getEmailotp = async (email) => {
const response = await basicAxios.get(`/api/Account/SendSecurityCodeToEmail?email=${email}`);
  return response.data;
};

export const getPhoneotp = async (number) => {
const response = await basicAxios.get(`/api/Account/SendSecurityCodeToPhone?phone=${number}`);
  return response;
};

export const SecurityQData = async () => {
const response = await basicAxios.get(`/api/Account/GetSecurityQuestions`);
  return response;
};

export const getAddedSecurityQuestionList = async (data) => {
const response = await basicAxios.post(`/api/Account/AddSecurityQuestion`, data);
  return response;
};

export const verifyAddedSecurityQuestionList = async (data) => {
const response = await basicAxios.post(`/api/Account/VerifySecurityQuestion`, data);
  return response;
};

export const getverifyOtpCodeList = async (payload) => {
const response = await basicAxios.get(`/api/Account/VerifySecurityCode?email=${payload.otpmethodSelectordata}&code=${payload.otp}`);
  return response;
};

export const addNewUser = async (data) => {
  const response = await basicAxios.post("/api/Account/AddUser", data);
  return response.data;
};

export const filterUsers = async (data) => {
  const response = await basicAxios.post("/api/Account/FilterUsers", data);
  return response.data;
};

///LOGIN THROUGH LOGIN pg.
export const userLogin = async (data) => {
  const response = await basicAxios.post("/api/Account/Login", data);
  return response.data
};
///LOGOUT USER
export const userLogout = async () => {
  const response = await basicAxios.post("/api/Account/Logout");
  return response.data
};

//RefreshMyAccToken
export const refresh = async () => {
  const response = await basicAxios.get("/api/Account/Refresh");
  return response.data;
};

//Change Password
export const changePassword = async (data) => {
  const response = await basicAxios.post("/api/Account/ChangePassword", data);
  return response.data;
};

export const getUplImageUserById = async (formData) => {
  const response = await basicAxios.post("/api/Account/UploadUserProfilePic", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getResetUserImpPassU = async (formData) => {
  const response = await basicAxios.post("/api/Account/ResetPassword", formData);
  return response.data;
};
